<!--
 * @Author: Junjie
 * @Date: 2023-08-27 16:38:11
 * @LastEditTime: 2023-08-27 19:12:46
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/general/docs/PlantDocsList.vue
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="年份">
              <a-select
                :options="yearOptions"
                @change="searchQuery"
                allowClear
                placeholder="请选择年份"
                v-model="docYear"
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="文档名称">
              <a-input placeholder="请输入文档名称" v-debounce="searchQuery" v-model="queryParam.docName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-model-item label="负责人" prop="manager">
              <j-dict-select-tag
                :dictCode="sysPersonDictCode"
                @change="searchQuery"
                placeholder="请选择负责人"
                type="list"
                v-model="queryParam.manager"
              />
            </a-form-model-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <j-super-query
        :fieldList="superFieldList"
        @handleSuperQuery="handleSuperQuery"
        ref="superQueryModal"
      ></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="previewSlot" slot-scope="text, record">
          <a-button @click="previewFile(record.docUrl)" size="small" type="link" v-if="record.docUrl">{{
            text
          }}</a-button>
          <span v-else>{{ text }}</span>
        </template>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
            >下载</a-button
          >
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />

          <a @click="downloadFile(record.docUrl)">下载</a>

          <a-divider type="vertical" />
          <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
            <a type="danger">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <plant-docs-modal @ok="modalFormOk" ref="modalForm"></plant-docs-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { deleteAction, getAction } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import PlantDocsModal from './modules/PlantDocsModal.vue'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import moment from 'dayjs'
import PlantDocsForm from './modules/PlantDocsForm.vue'

export default {
  name: 'PlantDocsList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    PlantDocsModal
  },
  data() {
    return {
      description: '安全文档库管理页面',
      treeCollapsed: false,
      bizType: 'secure-act',
      docType: 'A03',
      yearOptions: [],
      docYear: '',
      yearShowOne: false,
      sysPersonDictCode: `sys_user,realname,id,rel_tenant_ids='${this.$ls.get('TENANT_ID')}'`,
      // 表头
      columns: [
        {
          title: '文档名称',
          align: 'center',
          sorter: true,
          dataIndex: 'docName',
          scopedSlots: { customRender: 'previewSlot' }
        },
        {
          title: '日期',
          align: 'center',
          sorter: true,
          dataIndex: 'docDate',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          }
        },
        {
          title: '存档日期',
          align: 'center',
          sorter: true,
          dataIndex: 'saveDate',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          }
        },
        {
          title: '负责人',
          align: 'center',
          sorter: true,
          dataIndex: 'manager_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/doc/commonDocs/list',
        delete: '/doc/commonDocs/delete',
        deleteBatch: '/doc/commonDocs/deleteBatch',
        exportXlsUrl: '/doc/commonDocs/exportXls',
        importExcelUrl: 'doc/commonDocs/importExcel',

        typeRootList: '/doc/commonDocsType/rootList',
        typeChildList: '/doc/commonDocsType/childList',
        getTypeChildListBatch: '/doc/commonDocsType/getChildListBatch'
      },
      dictOptions: {},
      superFieldList: []
    }
  },
  created() {
    this.getSuperFieldList()
    const thisYear = new Date().getFullYear()
    for (let index = 0; index < 20; index++) {
      const option = {
        key: thisYear - index,
        value: thisYear - index,
        title: `${thisYear - index}年`
      }
      this.yearOptions.push(option)
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams() // 查询条件
      if (this.docYear) {
        params.docDate_begin = `${this.docYear}-01-01 00:00:00`
        params.docDate_end = `${this.docYear}-12-31 23:59:59`
      }
      if (this.docType) {
        params.docType = `${this.docType}*`
      }
      if (this.bizType) {
        params.bizType = this.bizType
      }
      this.loading = true
      getAction(this.url.list, params)
        .then(res => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSelect(docType) {
      this.docType = docType
      this.searchQuery()
    },
    // 弹出日历和关闭日历的回调
    openChangeOne(status) {
      //status是打开或关闭的状态
      if (status) {
        this.yearShowOne = true
      }
    },
    // 得到年份选择器的值
    onYearChange(value) {
      this.docYear = moment(value).format('YYYY')
      this.yearShowOne = false
    },
    previewFile(fileUrl) {
      const buf = Buffer.from(fileUrl)
      let url = window._CONFIG['onlinePreviewDomainURL'] + '?url=' + encodeURIComponent(buf.toString('base64'))
      window.open(url, '_blank')
    },
    handleAdd: function() {
      this.$refs.modalForm.add(this.docType)
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'docName', text: '文档名称', dictCode: '' })
      fieldList.push({ type: 'string', value: 'docUrl', text: '文档路径', dictCode: '' })
      fieldList.push({ type: 'string', value: 'docType', text: '业务分类', dictCode: 'common_docs_type,type_name,id' })
      fieldList.push({ type: 'string', value: 'compUnit', text: '主管单位', dictCode: 'doc_comp_unit' })
      fieldList.push({ type: 'date', value: 'docDate', text: '日期' })
      fieldList.push({ type: 'date', value: 'saveDate', text: '存档日期' })
      fieldList.push({ type: 'string', value: 'manager', text: '负责人', dictCode: '' })
      fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
.edit-table {
  &-collapsed {
    width: calc(100% - 50px);
  }
  &-full {
    width: calc(100% - 308px);
  }
}
</style>
